import React from 'react';
import { createElevChart } from '../../../../../utils/elev/elev_chart';
import { processGroupedSegments, getGroupedSegments } from '../../../../../utils/elev/elev_pane_helpers';

const createReactClass = require('create-react-class');

const MapElevationPaneWidget = createReactClass({
  componentDidMount() {
    this._isMounted = true;
    this.pointByPointSegmented = null;
    this.totalDistance = null;
    this.colorsSegmented = null;
    this.createElevationGraph();
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('orientationchange', this.handleResize);
  },
  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('orientationchange', this.handleResize);
  },
  handleResize() {
    this.redrawElevationGraph();
  },
  redrawElevationGraph() {
    if (!this.pointByPointSegmented) {
      return;
    }
    this.drawElevationGraph(this.pointByPointSegmented, this.colorsSegmented, this.totalDistance);
  },
  drawElevationGraph(pointByPointSegmented, colorsSegmented, totalDistance) {
    if (!this._isMounted) {
      return;
    }
    this.pointByPointSegmented = pointByPointSegmented;
    this.colorsSegmented = colorsSegmented;
    this.totalDistance = totalDistance;
    const { displayMetric, elevationConfig, handleMouseOver, height, showStatsGroup, width } = this.props;
    createElevChart({
      colorsSegmented,
      displayMetric,
      dom: this.refs.elevChart,
      elevationConfig,
      handleMouseOver,
      height,
      paddingWidth: 14,
      pointByPointSegmented,
      showStatsGroup,
      totalDistance,
      width
    });
  },
  createElevationGraph() {
    const groupedSegments = getGroupedSegments(this.props.map);
    const segments = groupedSegments.map(group => group.segments).flat();
    const colorsSegmented = groupedSegments.map(group => group.color);

    // Special handling for no segments
    if (segments.length < 1) {
      this.drawElevationGraph([], 0, []);
      return;
    }

    // Calculate elevPointByPoint and totalDistance
    const { pointByPointSegmented, totalDistance } = processGroupedSegments(groupedSegments, this.props.displayMetric);
    this.drawElevationGraph(pointByPointSegmented, colorsSegmented, totalDistance);
  },
  render() {
    return (
      <div key="elevBox" id="elevation-box" className="unselectable">
        <div id="elevation-chart" ref="elevChart" />
      </div>
    );
  }
});

MapElevationPaneWidget.defaultProps = {
  elevationConfig: {},
  showStatsGroup: false
};

export { MapElevationPaneWidget };
